import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

function Contact() {
  const { language } = useLanguage();

  const whatsappNumber =
    "355697555461";

  const phoneNumber =
    "+355 69 755 5461";

  const instagramUrl =
    "https://www.instagram.com/autorent.albania?igsi=NTZzNDBiMjJ4YTRr&utm_source=qr";

  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=41.422878,19.712574";

  const translations = {
    en: {
      contactLabel:
        "Contact AutoRent Albania",
      title1: "We are here when",
      title2: "you need us.",
      intro:
        "Contact us directly for bookings, availability, questions or help choosing the right car for your trip in Albania.",

      getInTouch: "GET IN TOUCH",
      chooseContact:
        "Choose how you want to contact us.",

      whatsapp: "WHATSAPP",
      messageUs: "Message us",
      whatsappText:
        "Fastest way to ask about availability, reservations or your current booking.",

      phone: "PHONE",
      phoneText:
        "Tap to call AutoRent Albania directly from your phone.",

      instagram: "INSTAGRAM",
      instagramText:
        "Follow us to see our fleet, latest cars and updates.",

      locationLabel: "OUR LOCATION",
      locationTitle1:
        "Find AutoRent",
      locationTitle2: "Albania.",
      locationText:
        "We are located near Tirana International Airport, Rinas. Open the map for navigation and directions.",

      address: "ADDRESS",
      airport:
        "Tirana International Airport (Rinas)",
      rinas: "Rinas, Tirana, Albania",

      convenient:
        "Convenient location",
      convenientText:
        "Just minutes from the airport.",

      easyAccess: "Easy access",
      easyAccessText:
        "Quick and simple to reach by car.",

      openMaps:
        "Open in Google Maps",

      quickAnswers:
        "QUICK ANSWERS",
      faqTitle:
        "Frequently asked questions.",

      question1:
        "How do I check which cars are available?",
      answer1:
        "Open the Booking page, select your pickup and return dates and times, then click Check Available Cars.",

      question2:
        "Is the online request automatically confirmed?",
      answer2:
        "No. Your request is sent as pending. AutoRent Albania will contact you to confirm the reservation.",

      question3:
        "Can I contact you before booking?",
      answer3:
        "Yes. You can call us, message us on WhatsApp or contact us through Instagram.",

      question4:
        "Can I see all photos of a vehicle?",
      answer4:
        "Yes. Open Cars & Prices and select a vehicle to view its full photo gallery and details.",

      ready:
        "Ready to reserve your car?",
      readyText:
        "Check availability online or message us directly on WhatsApp.",

      checkAvailability:
        "Check Availability",
      whatsappUs: "WhatsApp Us",
    },

    sq: {
      contactLabel:
        "Kontakto AutoRent Albania",
      title1: "Jemi këtu kur",
      title2: "ke nevojë për ne.",
      intro:
        "Na kontakto direkt për rezervime, disponueshmëri, pyetje ose ndihmë për të zgjedhur makinën e duhur për udhëtimin tënd në Shqipëri.",

      getInTouch:
        "NA KONTAKTO",
      chooseContact:
        "Zgjidh mënyrën se si dëshiron të na kontaktosh.",

      whatsapp: "WHATSAPP",
      messageUs: "Na shkruaj",
      whatsappText:
        "Mënyra më e shpejtë për të pyetur për disponueshmërinë, rezervimet ose rezervimin tënd aktual.",

      phone: "TELEFON",
      phoneText:
        "Prek numrin për të telefonuar direkt AutoRent Albania.",

      instagram: "INSTAGRAM",
      instagramText:
        "Na ndiq për të parë flotën tonë, makinat dhe përditësimet më të fundit.",

      locationLabel:
        "VENDNDODHJA JONË",
      locationTitle1:
        "Gjej AutoRent",
      locationTitle2: "Albania.",
      locationText:
        "Ndodhemi pranë Aeroportit Ndërkombëtar të Tiranës, Rinas. Hap hartën për navigim dhe udhëzime.",

      address: "ADRESA",
      airport:
        "Aeroporti Ndërkombëtar i Tiranës (Rinas)",
      rinas: "Rinas, Tiranë, Shqipëri",

      convenient:
        "Vendndodhje e përshtatshme",
      convenientText:
        "Vetëm disa minuta nga aeroporti.",

      easyAccess:
        "Akses i lehtë",
      easyAccessText:
        "E shpejtë dhe e thjeshtë për t'u arritur me makinë.",

      openMaps:
        "Hap në Google Maps",

      quickAnswers:
        "PYETJE TË SHPESHTA",
      faqTitle:
        "Pyetje të shpeshta.",

      question1:
        "Si mund të kontrolloj makinat e disponueshme?",
      answer1:
        "Hap faqen e Rezervimit, zgjidh datën dhe orën e marrjes dhe kthimit, më pas kliko Kontrollo Makinat e Disponueshme.",

      question2:
        "A konfirmohet automatikisht kërkesa online?",
      answer2:
        "Jo. Kërkesa dërgohet si në pritje. AutoRent Albania do të të kontaktojë për të konfirmuar rezervimin.",

      question3:
        "A mund t'ju kontaktoj përpara rezervimit?",
      answer3:
        "Po. Mund të na telefonosh, të na shkruash në WhatsApp ose të na kontaktosh në Instagram.",

      question4:
        "A mund t'i shoh të gjitha fotot e makinës?",
      answer4:
        "Po. Hap Makinat & Çmimet dhe zgjidh një makinë për të parë galerinë e plotë dhe detajet.",

      ready:
        "Gati për të rezervuar makinën?",
      readyText:
        "Kontrollo disponueshmërinë online ose na shkruaj direkt në WhatsApp.",

      checkAvailability:
        "Kontrollo Disponueshmërinë",
      whatsappUs:
        "Na shkruaj në WhatsApp",
    },
  };

  const t = translations[language];

  const sectionStyle = {
    width:
      "min(1200px, calc(100% - 40px))",
    margin: "0 auto",
  };

  const cardStyle = {
    background: "#ffffff",
    border: "1px solid #e7e7e7",
    borderRadius: "20px",
    padding: "24px",
    boxShadow:
      "0 8px 28px rgba(0,0,0,0.05)",
  };

  return (
    <div>
      {/* HERO */}
      <section
        style={{
          background: "#111317",
          color: "#ffffff",
          padding: "80px 0",
        }}
      >
        <div style={sectionStyle}>
          <p
            style={{
              margin: "0 0 12px",
              color: "#9ea3aa",
              fontSize: "12px",
              fontWeight: "900",
              textTransform:
                "uppercase",
              letterSpacing: "2px",
            }}
          >
            {t.contactLabel}
          </p>

          <h1
            style={{
              margin: "0 0 20px",
              maxWidth: "750px",
              fontSize:
                "clamp(42px, 6vw, 68px)",
              lineHeight: "1",
              letterSpacing: "-3px",
            }}
          >
            {t.title1}
            <br />
            {t.title2}
          </h1>

          <p
            style={{
              margin: 0,
              maxWidth: "650px",
              color: "#a6abb2",
              fontSize: "17px",
              lineHeight: "1.7",
            }}
          >
            {t.intro}
          </p>
        </div>
      </section>

      {/* CONTACT CARDS */}
      <section
        style={{
          background: "#f5f5f5",
          padding: "80px 0",
        }}
      >
        <div style={sectionStyle}>
          <div
            style={{
              marginBottom: "36px",
            }}
          >
            <p
              style={{
                margin: "0 0 8px",
                color: "#777",
                fontSize: "12px",
                fontWeight: "900",
                letterSpacing: "2px",
              }}
            >
              {t.getInTouch}
            </p>

            <h2
              style={{
                margin: 0,
                fontSize:
                  "clamp(34px, 5vw, 50px)",
                letterSpacing: "-2px",
              }}
            >
              {t.chooseContact}
            </h2>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "20px",
            }}
          >
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={cardStyle}
            >
              <ContactIcon type="whatsapp" />

              <p style={labelStyle}>
                {t.whatsapp}
              </p>

              <h3 style={cardTitleStyle}>
                {t.messageUs}
              </h3>

              <p style={cardTextStyle}>
                {t.whatsappText}
              </p>
            </a>

            <a
              href="tel:+355697555461"
              style={cardStyle}
            >
              <ContactIcon type="phone" />

              <p style={labelStyle}>
                {t.phone}
              </p>

              <h3 style={cardTitleStyle}>
                {phoneNumber}
              </h3>

              <p style={cardTextStyle}>
                {t.phoneText}
              </p>
            </a>

            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={cardStyle}
            >
              <ContactIcon type="instagram" />

              <p style={labelStyle}>
                {t.instagram}
              </p>

              <h3 style={cardTitleStyle}>
                @autorent.albania
              </h3>

              <p style={cardTextStyle}>
                {t.instagramText}
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* LOCATION */}
      <section
        style={{
          background: "#ffffff",
          padding: "85px 0",
        }}
      >
        <div style={sectionStyle}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "32px",
              alignItems: "stretch",
            }}
          >
            <div
              style={{
                flex: "1 1 600px",
                minHeight: "470px",
                borderRadius: "22px",
                overflow: "hidden",
                background: "#e9e9e9",
                border:
                  "1px solid #e5e5e5",
              }}
            >
              <iframe
                title="AutoRent Albania Location"
                src="https://www.google.com/maps?q=41.422878,19.712574&z=15&output=embed"
                width="100%"
                height="100%"
                style={{
                  minHeight: "470px",
                  border: 0,
                  display: "block",
                }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div
              style={{
                flex: "1 1 330px",
                maxWidth: "440px",
                width: "100%",
                background: "#111317",
                color: "#ffffff",
                borderRadius: "22px",
                padding: "30px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p
                style={{
                  margin: "0 0 9px",
                  color: "#92979e",
                  fontSize: "12px",
                  fontWeight: "900",
                  letterSpacing: "1.8px",
                }}
              >
                {t.locationLabel}
              </p>

              <h2
                style={{
                  margin: "0 0 18px",
                  fontSize:
                    "clamp(30px, 4vw, 38px)",
                  lineHeight: "1.05",
                }}
              >
                {t.locationTitle1}
                <br />
                {t.locationTitle2}
              </h2>

              <p
                style={{
                  margin: "0 0 24px",
                  color: "#a6abb2",
                  fontSize: "15px",
                  lineHeight: "1.7",
                }}
              >
                {t.locationText}
              </p>

              <div
                style={{
                  padding: "18px",
                  borderRadius: "15px",
                  background:
                    "rgba(255,255,255,0.07)",
                  marginBottom: "22px",
                }}
              >
                <span
                  style={{
                    display: "block",
                    color: "#92979e",
                    fontSize: "11px",
                    fontWeight: "800",
                    letterSpacing: "1px",
                    marginBottom: "7px",
                  }}
                >
                  {t.address}
                </span>

                <strong
                  style={{
                    display: "block",
                    fontSize: "16px",
                    lineHeight: "1.4",
                  }}
                >
                  {t.airport}
                </strong>

                <span
                  style={{
                    display: "block",
                    marginTop: "5px",
                    color: "#9da2a9",
                    fontSize: "14px",
                  }}
                >
                  {t.rinas}
                </span>
              </div>

              <LocationFeature
                title={t.convenient}
                text={t.convenientText}
              />

              <LocationFeature
                title={t.easyAccess}
                text={t.easyAccessText}
              />

              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "block",
                  width: "100%",
                  padding: "15px",
                  marginTop: "auto",
                  background: "#ffffff",
                  color: "#111317",
                  borderRadius: "12px",
                  textAlign: "center",
                  fontWeight: "900",
                }}
              >
                {t.openMaps}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section
        style={{
          background: "#f2f2f2",
          padding: "85px 0",
        }}
      >
        <div style={sectionStyle}>
          <p style={labelStyle}>
            {t.quickAnswers}
          </p>

          <h2
            style={{
              margin: "0 0 38px",
              fontSize:
                "clamp(34px, 5vw, 50px)",
              letterSpacing: "-2px",
            }}
          >
            {t.faqTitle}
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(280px, 1fr))",
              gap: "16px",
            }}
          >
            {[
              [
                t.question1,
                t.answer1,
              ],
              [
                t.question2,
                t.answer2,
              ],
              [
                t.question3,
                t.answer3,
              ],
              [
                t.question4,
                t.answer4,
              ],
            ].map(
              ([question, answer]) => (
                <div
                  key={question}
                  style={{
                    background:
                      "#ffffff",
                    padding: "24px",
                    borderRadius:
                      "18px",
                    border:
                      "1px solid #e5e5e5",
                  }}
                >
                  <h3
                    style={{
                      margin:
                        "0 0 12px",
                      fontSize:
                        "18px",
                      lineHeight:
                        "1.35",
                    }}
                  >
                    {question}
                  </h3>

                  <p
                    style={{
                      margin: 0,
                      color: "#6d6d6d",
                      fontSize:
                        "14px",
                      lineHeight:
                        "1.7",
                    }}
                  >
                    {answer}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section
        style={{
          background: "#111317",
          color: "#ffffff",
          padding: "80px 0",
        }}
      >
        <div
          style={{
            ...sectionStyle,
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin:
                "0 auto 18px",
              maxWidth: "750px",
              fontSize:
                "clamp(36px, 5vw, 54px)",
              letterSpacing: "-2px",
            }}
          >
            {t.ready}
          </h2>

          <p
            style={{
              margin:
                "0 auto 28px",
              maxWidth: "560px",
              color: "#a0a5ac",
              fontSize: "16px",
              lineHeight: "1.7",
            }}
          >
            {t.readyText}
          </p>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            <Link
              to="/booking"
              style={{
                padding:
                  "15px 22px",
                borderRadius:
                  "12px",
                background:
                  "#ffffff",
                color: "#111317",
                fontWeight: "900",
              }}
            >
              {t.checkAvailability}
            </Link>

            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding:
                  "15px 22px",
                borderRadius:
                  "12px",
                border:
                  "1px solid rgba(255,255,255,0.18)",
                color: "#ffffff",
                fontWeight: "900",
              }}
            >
              {t.whatsappUs}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

function ContactIcon({ type }) {
  return (
    <div
      style={{
        width: "48px",
        height: "48px",
        borderRadius: "14px",
        background: "#111317",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "28px",
        fontWeight: "900",
      }}
    >
      {type === "whatsapp"
        ? "W"
        : type === "phone"
        ? "☎"
        : "◎"}
    </div>
  );
}

function LocationFeature({
  title,
  text,
}) {
  return (
    <div
      style={{
        marginBottom: "18px",
      }}
    >
      <strong
        style={{
          display: "block",
          fontSize: "15px",
          marginBottom: "4px",
        }}
      >
        {title}
      </strong>

      <span
        style={{
          color: "#9da2a9",
          fontSize: "13px",
        }}
      >
        {text}
      </span>
    </div>
  );
}

const labelStyle = {
  margin: "0 0 7px",
  color: "#888",
  fontSize: "12px",
  fontWeight: "800",
  letterSpacing: "1px",
};

const cardTitleStyle = {
  margin: "0 0 10px",
  fontSize: "22px",
};

const cardTextStyle = {
  margin: 0,
  color: "#666",
  lineHeight: "1.6",
  fontSize: "14px",
};

export default Contact;